import React from 'react';
import PrivateRoute from './PrivateRoute';

const PublicRoute = ( props ) => {
  const {isAuthenticated, ...rest} = props;
  return (<PrivateRoute {...rest} isAuthenticated={! isAuthenticated}/>);
};
export default PublicRoute;